import gql from 'graphql-tag';

const fragments = {
  person: gql`
    fragment PersonFragment on Person {
      id
      name
      info
      twitter
      fb
      created_at
      updated_at
    }
  `,
  post: gql`
    fragment PostFragment on Post {
      id
      created_at
      updated_at
      date
      body
    }
  `,
};

export const REQUEST_LOGIN_CODE_MUTATION = gql`
  mutation requestLoginCode($email: String!) {
    requestLoginCode(email: $email) {
      id
      remaining_tries
      expires_at
      created_at
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation login($email: String!, $code: String!) {
    login(email: $email, code: $code) {
      token
      code {
        id
        remaining_tries
        expires_at
        created_at
      }
      error
      user {
        name
        email_addresses
      }
    }
  }
`;

export const UPSERT_PERSON_MUTATION = gql`
  mutation upsertPerson(
    $id: ID
    $name: String
    $info: String
    $fb: String
    $twitter: String
  ) {
    person: upsertPerson(
      id: $id
      name: $name
      info: $info
      fb: $fb
      twitter: $twitter
    ) {
      ...PersonFragment
    }
  }

  ${fragments.person}
`;

export const UPSERT_POST_MUTATION = gql`
  mutation upsertPost($person_id: ID, $id: ID, $body: String, $date: DateTime) {
    post: upsertPost(person_id: $person_id, id: $id, body: $body, date: $date) {
      ...PostFragment
    }
  }

  ${fragments.post}
`;

export const DELETE_PERSON_MUTATION = gql`
  mutation deletePerson($id: ID!) {
    person: deletePerson(id: $id) {
      ...PersonFragment
    }
  }
  ${fragments.person}
`;

// QUERIES

export const ME_QUERY = gql`
  query me {
    me {
      name
      email_addresses
    }
  }
`;

export const PEOPLE_QUERY = gql`
  query people($limit: Int, $offset: Int, $query: String) {
    people: People(limit: $limit, offset: $offset, query: $query) {
      ...PersonFragment
    }
  }
  ${fragments.person}
`;

export const PERSON_QUERY = gql`
  query PersonQuery($id: ID) {
    person: Person(id: $id) {
      ...PersonFragment
      locations {
        id
        lat
        lon
        name
        body
      }
      posts {
        ...PostFragment
      }
    }
  }
  ${fragments.person}
  ${fragments.post}
`;

export const peopleQueryVariables = {
  offset: 0,
  limit: 20,
  query: '',
};



// WEBPACK FOOTER //
// ./src/graphql.js